import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IsJsonString } from '@/plugins/helpers'

import EditorJs from '@editorjs/editorjs'
// @ts-ignore
import Header from '@editorjs/header'
// @ts-ignore
// import LinkTool from '@editorjs/link';
// @ts-ignore
import List from '@editorjs/list'
// @ts-ignore
import Embed from '@editorjs/embed'
// @ts-ignore
import Quote from '@editorjs/quote'
// @ts-ignore
import Table from '@editorjs/table'
// @ts-ignore
import Delimiter from '@editorjs/delimiter'
// @ts-ignore
import Marker from '@editorjs/marker'
// @ts-ignore
import Underline from '@editorjs/underline'

import Mention from '@/components/Editor/mention'

import VBITImage from '@/components/Editor/vbit-image'
import { isObjectLike } from 'lodash'

function turnEditorJSToRichText(data: any) {
    if (data.blocks.length > 0) {
        return JSON.stringify({ type: 'editorjs', data: data })
    }

    return null
}

export let defaultRichTextValue = (value = '') =>
    turnEditorJSToRichText({
        time: Date.now(),
        blocks: [{ type: 'paragraph', data: { text: value } }],
        version: '2.8.1',
    })

@Component({
    methods: { IsJsonString },
    inheritAttrs: false,
})
export default class Editor extends Vue {
    @Prop({
        default: () => [
            'header',
            'linkTool',
            'list',
            'embed',
            'quote',
            'table',
            'delimiter',
            'Marker',
            'underline',
        ],
    })
    tools!: any
    @Prop() init!: any
    @Prop() placeholder!: any
    @Prop() clear!: any
    @Prop() index!: any
    @Prop() focus!: any
    @Prop({ default: 130 }) minHeight!: number

    editorData = this.init
    editor: any = null
    editorElement: any = null
    toolsSet: any = {}

    get isToolboxOpen() {
        // return this.editorElement ? this.editorElement.getElementsByClassName('codex-editor--toolbox-opened').length > 0 : false
        return this.editorElement
            ? this.editorElement.getElementsByClassName('codex-editor--toolbox-opened')
            : []
    }

    get isToolbarOpen() {
        return this.editorElement
            ? this.editorElement.getElementsByClassName('ce-toolbar--opened').length
            : 'ha'
    }

    get isInlineToolbarOpen() {
        return this.editorElement
            ? this.editorElement.getElementsByClassName('ce-inline-toolbar--showed').length > 0
            : false
    }

    get isActive() {
        return this.isToolboxOpen
    }

    async mounted() {
        // first render editor js div and only after create editorJS instance
        await this.$nextTick()
        if (this.tools) {
            this.setTools()
        }

        this.editor = new EditorJs({
            holder: `${this.index}`,
            minHeight: this.minHeight,
            autofocus: this.focus,
            data: this.description,
            tools: this.toolsSet,
            placeholder: this.placeholder,
            onChange: async () => {
                await this.passText()
            },
            // inlineToolbar: ['link', Mention],
            hideToolbar: true,
        })

        this.editorElement = document.getElementById(this.index) // your "holder" ID

        document.addEventListener(
            'click',
            () => {
                if (!this.editorData) {
                    this.editorElement?.classList?.add('onBlured')
                    this.editor.placeholder = this.placeholder
                    this.editor.minHeight = this.minHeight
                }
            },
            { capture: true }
        )
    }

    get description() {
        let res: any = null

        if (this.init) {
            if (IsJsonString(this.init)) {
                let parsedInit = JSON.parse(this.init)
                if (parsedInit.type) {
                    if (parsedInit.type == 'editorjs') {
                        res = parsedInit.data
                    } else if (parsedInit.type == 'text') {
                        res = { blocks: [{ type: 'paragraph', data: { text: parsedInit.data } }] }
                    }
                } else {
                    res = parsedInit
                }
            } else {
                res = { blocks: [{ type: 'paragraph', data: { text: this.init } }] }
            }
        }

        return res
    }

    @Watch('index')
    createEditor() {
        if (this.init) {
            this.editor.render(this.description)
            this.editor.caret.focus(true)
        } else {
            this.editor.clear()
        }
    }

    beforeDestroy() {
        this.editor?.destroy?.()
    }

    setTools() {
        for (let i = 0; i < this.tools.length; i++) {
            let tool = this.tools[i]

            switch (tool) {
                case 'header':
                    Object.assign(this.toolsSet, {
                        header: Header,
                    })
                    break
                // case "linkTool":
                //     Object.assign(this.toolsSet, {
                //         linkTool: {
                //             class: LinkTool,
                //         }
                //     });
                //     break;
                case 'list':
                    Object.assign(this.toolsSet, {
                        list: {
                            class: List,
                            inlineToolbar: true,
                        },
                    })
                    break
                case 'embed':
                    Object.assign(this.toolsSet, {
                        embed: Embed,
                    })
                    break
                case 'quote':
                    Object.assign(this.toolsSet, {
                        quote: Quote,
                    })
                    break
                case 'table':
                    Object.assign(this.toolsSet, {
                        table: {
                            class: Table,
                        },
                    })
                    break
                case 'delimiter':
                    Object.assign(this.toolsSet, {
                        delimiter: Delimiter,
                    })
                    break
                case 'Marker':
                    Object.assign(this.toolsSet, {
                        Marker: {
                            class: Marker,
                            shortcut: 'CMD+SHIFT+M',
                        },
                    })
                    break

                case 'VBITImage':
                    Object.assign(this.toolsSet, {
                        vbitImage: {
                            class: VBITImage,
                        },
                    })
                    break
                // case "underline":
                //     Object.assign(this.toolsSet, {
                //         underline: Underline
                //     });
                //     break;
            }

            if (isObjectLike(tool)) {
                switch (tool.type) {
                    case 'VBITImage':
                        Object.assign(this.toolsSet, {
                            vbitImage: {
                                class: VBITImage,
                                config: tool.config,
                            },
                        })
                        break
                }
            }

            Object.assign(this.toolsSet, {
                Mention: {
                    class: Mention,
                    inlineToolbar: true,
                },
            })
        }
    }

    async passText() {
        await this.editor.save().then(async (outputData: any) => {
            let res = turnEditorJSToRichText(outputData)
            this.editorData = res
            this.$emit('passText', res)
        })
    }

    async handleEnter(input: any) {
        if (input.ctrlKey) {
            await this.editor.save().then(async (outputData: any) => {
                let res = turnEditorJSToRichText(outputData)
                this.editorData = res
                this.$emit('save', res)
            })

            if (this.clear) {
                this.editor.clear()
                this.editorData = null
            }
        }
    }

    clickedElement(e) {
        this.editorElement.classList.remove('onBlured')
        this.editor.minHeight = 0
    }
}
